import dayjs from "dayjs";
import pako from "pako";

export const serializeQueryString = function (obj, prefix) {
    let str = [],
            p;
    for (p in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            let k = prefix ? prefix + '[' + p + ']' : p,
                    v = obj[p];
            if (v !== null && v !== undefined) {
                str.push(
                        typeof v === 'object'
                                ? serializeQueryString(v, k)
                                : encodeURIComponent(k) + '=' + encodeURIComponent(v)
                );
            }
        }
    }
    return str.join('&');
};

export const getQueryParams = (url) => {
    const params = {};
    const qs = url.split('?')[1];
    if (!qs) {
        return params;
    }
    const pieces = qs.split('&');
    pieces.forEach((piece) => {
        const tmp = piece.split('=');
        params[tmp[0]] = tmp[1];
    });
    return params;
};

export const downloadPdfFromBuffer = (arrayBuffer, fileName) => {
    const buffer = new Uint8Array(arrayBuffer);
    downloadFileFromBuffer(buffer, fileName, 'application/pdf');
};

export const downloadFileFromBuffer = (buffer, fileName, type) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = window.URL.createObjectURL(new Blob([buffer], { type }));
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const convertBase64ToBuffer = (base64) => {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
};

export const findIntersection = (array1, array2) => {
    return array1.filter(function (n) {
        return array2.indexOf(n) !== -1;
    });
};

export const formatNow = (format = 'YYYY') => dayjs().format(format);

export const splitArray = (inputArray, chunk) => {
    return inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunk);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
};

export const formatPrice = (price) => {
    const formattedPrice = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return `$${formattedPrice}`;
};

export const formatOrderAddress = (order, type) => {
    if (
        order.order_details[`${type}_city`] &&
        (order.order_details[`${type}_state`] || order.order_details[`${type}_postcode`])
    )
        return `${order.order_details[`${type}_city`]}, ${order.order_details[`${type}_state`]} ${
            order.order_details[`${type}_postcode`]
        }`;

    return `${order.order_details[`${type}_city`]} ${order.order_details[`${type}_state`]} ${
        order.order_details[`${type}_postcode`]
    }`;
};

export const formatDate = (date, format = 'MM/DD/YYYY hh:mm A', utc = false) => {
    const value = dayjs.isDayjs(date) ? date.format('YYYY-MM-DD HH:mm:ss') : date;

    if (utc) {
        return dayjs(value, 'YYYY-MM-DD HH:mm:ss').isValid()
            ? dayjs(value, 'YYYY-MM-DD HH:mm:ss').format(format)
            : dayjs(value, 'YYYY-MM-DD HH:mm').format(format);
    }

    return dayjs.utc(value, 'YYYY-MM-DD HH:mm:ss').isValid()
        ? dayjs
            .utc(value, 'YYYY-MM-DD HH:mm:ss')
            .tz(window.ttg_timezone || 'America/Los_Angeles')
            .format(format)
        : dayjs
            .utc(value, 'YYYY-MM-DD HH:mm')
            .tz(window.ttg_timezone || 'America/Los_Angeles')
            .format(format);
};

export const padNumber = (value, pad) => {
    return value > 9 ? value : `${pad}${value}`;
};

export const groupByProp = (array, prop) => {
    return [...array].reduce((groups, item) => {
        const group = groups[item[prop]] || [];
        group.push(item);
        groups[item[prop]] = group;
        return groups;
    }, {});
};

export const parseToken = (token) => {
    try {
        const binaryString = atob(token);
        const compressed = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            compressed[i] = binaryString.charCodeAt(i);
        }

        const decompressed = pako.inflate(compressed, {to: 'string'});
        const data = JSON.parse(decompressed);

        if(Date.now() > Number(data.exp)){
            throw new Error(`Token is expired`);
        }

        return data;
    }
    catch (error) {
        return null;
    }
}